'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Llocales_cldr_NumberingSystem(id, digits) {
  this.vX = null;
  this.vW = null;
  this.vX = id;
  this.vW = digits;
}
export { $c_Llocales_cldr_NumberingSystem as $c_Llocales_cldr_NumberingSystem };
$p = $c_Llocales_cldr_NumberingSystem.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Llocales_cldr_NumberingSystem;
/** @constructor */
function $h_Llocales_cldr_NumberingSystem() {
}
export { $h_Llocales_cldr_NumberingSystem as $h_Llocales_cldr_NumberingSystem };
$h_Llocales_cldr_NumberingSystem.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().e7(this, (-889275714), null);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_NumberingSystem)) {
    if ((this.vX === x$0.vX)) {
      var x = this.vW;
      var x$2 = x$0.vW;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 2;
});
$p.o = (function() {
  return "NumberingSystem";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.vX;
  }
  if ((n === 1)) {
    return this.vW;
  }
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Llocales_cldr_NumberingSystem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.e2)));
}
export { $isArrayOf_Llocales_cldr_NumberingSystem as $isArrayOf_Llocales_cldr_NumberingSystem };
var $d_Llocales_cldr_NumberingSystem = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Llocales_cldr_NumberingSystem, "locales.cldr.NumberingSystem", ({
  e2: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Llocales_cldr_NumberingSystem as $d_Llocales_cldr_NumberingSystem };
